import { ActivityPart } from '@/api/models/activityParts'
import { ActivityWithAggregate } from '@/api/models/aggregate'
import { workflowStateUtils } from '@/utils/workflowStateUtils'

export const lastActivityWorkFlowInfo = (activityPart: ActivityPart<ActivityWithAggregate>) => {
  const activityWorkFlow = activityPart.childActivity.activityWorkflowAggregate?.lastActivityWorkflow

  return {
    activityWorkFlow,
    isFinished: workflowStateUtils.isFinished(activityWorkFlow),
  }
}
